import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

export interface OaValuesLine {
    label: string;
    value: string;
    tone?: 'discount' | 'muted';
}

/** ValuesSummary do DS (ORCA-1929): Itens, avulsos, Frete, Desconto geral → Total. */
@Component({
    selector: 'oa-values-summary',
    changeDetection: ChangeDetectionStrategy.OnPush,
    template: `
        <dl class="oa-values">
            <div *ngFor="let line of lines" class="oa-values__row"
                [class.oa-values__row--discount]="line.tone === 'discount'" [class.oa-values__row--muted]="line.tone === 'muted'">
                <dt>{{ line.label }}</dt>
                <dd>{{ line.value }}</dd>
            </div>
            <div class="oa-values__total" *ngIf="total">
                <dt>{{ totalLabel }}</dt>
                <dd>{{ total }}</dd>
            </div>
            <p class="oa-values__note" *ngIf="note">{{ note }}</p>
        </dl>
    `,
})
export class OaValuesSummaryComponent {
    @Input() lines: OaValuesLine[] = [];
    @Input() total?: string;
    @Input() totalLabel = 'Total';
    @Input() note?: string;
}
